import urlConfig from '../configs/url-config'
import fetchUtil from '../util/fetchUtil'

const addToMailingList = async (listName, data) => {
  const method = 'PUT'
  const url = `${urlConfig.functionsBaseUrl}/mailingList/add-to-mailing-list/${listName}`
  data = { contacts: data }
  const response = await fetchUtil.request({ method, url, data })
  let found = 0
  if (response.ok) {
    ({ found } = await response.json())
  } else {
    throw new Error(`Unexpected mailing list error ${response.status}`)
  }
  return { found }
}

export {
  addToMailingList
}
